import { ReactComponent as TrashCan } from "../../../assets/media_icons/trash.svg";
import { ReactComponent as Resume } from "../../../assets/media_icons/resume.svg";
import { ReactComponent as Pause } from "../../../assets/media_icons/pause.svg";
import "./MediaPlayer.css";

const MediaPlayer = ({
    time = "",
    progress = 0,
    step = .1,
    minValue = 0,
    maxValue = 100,
    disabled = false,
    displayDiscardButton = false,
    onClickDiscard = () => { },
    displayPlayButton = false,
    isPlaying = false,
    onClickPlay = () => { },
    onChangeSeekBar = () => { },
    leftElement = null,
}) => {

    const handleSeek = (e) => {
        onChangeSeekBar(e.target.value)
    }

    return (
        <div className="media-player">
            {!displayDiscardButton && leftElement}
            {displayDiscardButton &&
                <button disabled={disabled} className="media-player-trash" onClick={onClickDiscard}>
                    <TrashCan width={30} height={30} />
                </button>}
            {displayPlayButton &&
                <button disabled={disabled} className="media-player-icon" onClick={onClickPlay}>
                    {isPlaying ? <Pause width={30} height={30} className="media-player-play" /> : <Resume width={30} height={30} className="media-player-play" />}
                </button>
            }
            {/* seek slider */}
            <div className="media-player-seek-slider-container">
                <input
                    className="media-player-seek-slider"
                    type="range"
                    name="seek-slider"
                    id="seek-slider"
                    min={minValue}
                    max={maxValue}
                    step={step}
                    value={progress}
                    onChange={handleSeek}
                />
            </div>
            {/* time */}
            <span className="media-player-time">{time}</span>
        </div>
    )
}

export default MediaPlayer;